import { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskLines } from "./Motion";
import { BgVideo } from "./BgVideo";
import { ProcessTicker, E2E_VIDEO, E2E_POSTER } from "./ProcessTicker";

export const PageHero = ({ eyebrow, lines, children, crumbs = [], image, video = false, testId }) => {
  const vid = useRef(null);
  return (
    <section data-testid={testId} className="noise relative overflow-hidden bg-[#07090e] pb-16 pt-36 text-white md:pb-24 md:pt-44">
      {video ? (
        <BgVideo ref={vid} testId={`${testId}-video`} src={E2E_VIDEO} poster={E2E_POSTER} className="absolute inset-0 h-full w-full object-cover opacity-75" />
      ) : (
        image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-[#07090e]/95 via-[#07090e]/60 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#07090e]/80 via-transparent to-transparent" />
      <div className="grid-lines absolute inset-0 opacity-50" />
      <div className="container-x relative">
        {crumbs.length > 0 && (
          <nav data-testid="breadcrumbs" className="font-mono-x mb-8 flex flex-wrap items-center gap-2 text-[11px] uppercase tracking-widest text-slate-300">
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-2">
                {c.to ? <Link to={c.to} className="hover:text-sky-400">{c.label}</Link> : <span className="text-white">{c.label}</span>}
                {i < crumbs.length - 1 && <ChevronRight className="h-3 w-3" />}
              </span>
            ))}
          </nav>
        )}
        <div className="flex flex-col justify-between gap-10 lg:flex-row lg:items-end">
          <div>
            <p className="eyebrow text-sky-400">{eyebrow}</p>
            <MaskLines lines={lines} className="font-display mt-5 text-5xl font-black uppercase leading-[0.88] sm:text-6xl lg:text-8xl" lineClass="text-white" />
            {children && <div className="mt-8 max-w-2xl text-sm leading-relaxed text-slate-200 md:text-base">{children}</div>}
          </div>
          {video && <ProcessTicker videoRef={vid} className="w-full max-w-sm shrink-0" />}
        </div>
      </div>
    </section>
  );
};
